'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createHeaderText = function createHeaderText() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return name.split(/(?=[A-Z])/).join(' ').toLowerCase();
};

/* eslint jsx-a11y/no-static-element-interactions: 0 */

var Header = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          sortIdx = _props.sortIdx,
          sortable = _props.sortable,
          onHeaderCellClick = _props.onHeaderCellClick,
          headerRow = _props.headerRow;


      return _react2.default.createElement(
        'thead',
        { className: 'ui-table__header' },
        headerRow && headerRow(),
        _react2.default.createElement(
          'tr',
          { className: 'ui-table__row' },
          columns.map(function (_ref, i) {
            var header = _ref.header,
                className = _ref.className,
                key = _ref.key;
            return _react2.default.createElement(
              'th',
              {
                className: (0, _classnames2.default)('ui-table__cell', 'ui-table__cell_header', className, sortable && sortIdx === i && 'ui-table__cell_sorted'),
                key: key,
                onClick: sortable && sortIdx !== i && function () {
                  return onHeaderCellClick(i, key);
                } || function () {
                  return null;
                }
              },
              _react2.default.createElement(
                'span',
                { className: 'ui-table__cellContent' },
                (0, _lodash.isFunction)(header) ? header() : header || createHeaderText(key)
              )
            );
          })
        )
      );
    }
  }]);

  return Header;
}(_react.PureComponent);

Header.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
  })).isRequired,
  sortable: _propTypes2.default.bool,
  sortIdx: _propTypes2.default.number,
  onHeaderCellClick: _propTypes2.default.func,
  headerRow: _propTypes2.default.func
};

exports.default = Header;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/components/Header.js
// module id = 495
// module chunks = 0